import styled from "styled-components";
import MowicoLogo from "panel/src/assets/images/mowico.svg";

export default styled.img.attrs({ src: MowicoLogo })`
  position: absolute;
  left: 56px;
  top: 40px;
`;
